import { createI18nText } from '@hilma/netina2all';

const homePageText = createI18nText({
    he: {
        flowchart: {
            chooseKit: 'רוכשים משלוח מנות',
            pickAssociation: 'בוחרים עמותה אליה רוצים לתרום',
            charityProceeds: 'כל הרווחים נתרמים לצדקה',
        },
        alsoDonateBtn: 'גם אני רוצה לרכוש',
        donationInfo: {
            raisedThisYear: 'נתרמו עד כה השנה'
        },
        forDetails: 'לפרטים',
        goal: 'היעד:',
        shekel: 'ש"ח',
        bonusGoal: 'יעד בונוס:',
        distributionStationsBtn: 'תחנות חלוקה',
        aboutNet: {
            part1: 'עמותת "נתינת לולב" הינה עמותה ללא מטרות רווח,',
            part2: <>שקמה במטרה לתת נופך נוסף לתהליך רכישת ארבעת המינים - <strong>עשיית צדקה.</strong></>,
            part3n4: 'אנו פותחים בפניכם את האפשרות לרכוש את ארבעת המינים לחג הסוכות ובו בעת לתרום לעמותה שאותה תוכלו לבחור. ניתן לבחור מוצר מתוך מגוון רמות הידור.',
            part5: 'הכל נעשה בהתנדבות מלאה -',
            part6: 'מתחנות החלוקה עד המנהלים!',
            part7: 'חלק מהתרומה מוכר כתרומה לצורכי מס (לעמותה סעיף 46).'
        },
        sitemap: {
            howItWorks: 'איך זה עובד?',
            whoWeAre: 'מי אנחנו?',
            donateTo: 'למי תורמים?',
            distributionStations: 'לרשימת תחנות החלוקה',
            registerAssociation: 'לרישום לעמותה חדשה',
            registerDistStation: 'לפתיחת תחנת חלוקה חדשה בביתכם',
            enterProfile: 'לאזור האישי'
        },
        allOrgs: 'כל העמותות',
        siteNotOpening: 'חברים יקרים השנה המיזם "מתנות קטנות" לא יצא לפועל. רוב חברי המיזם במילואים בתקופה האחרונה ולצערנו לא הספקנו להתארגן השנה… ',
        willReturnNextYear: 'מבטיחים לחזור בכוחות מחודשים  בשנה הבאה, פורים שמח'
    },
    en: {
        flowchart: {
            chooseKit: 'Purchase a Mishloach Manot',
            pickAssociation: 'Choose an association you wish to donate to',
            charityProceeds: 'All the proceeds go to charity',
        },
        alsoDonateBtn: 'I also want to buy',
        donationInfo: {
            raisedThisYear: 'Money raised this year'
        },
        forDetails: 'For details',
        goal: 'Goal:',
        shekel: 'Shekel',
        bonusGoal: 'Bonus goal:',
        distributionStationsBtn: 'Distribution Stations',

        aboutNet: {
            part1: '"Netinat Lulav" is a non-profit organization',
            part2: 'that was established with the goal of adding an extra touch of charity to the process of acquiring the four species.',
            part3n4: 'We create a possibility for you to purchase the four species for Sukkot and at the same time donate to the association of your choice.  You can choose from our products that have varying levels of quality and beauty.',
            part5: 'Everything is done on a fully voluntary basis -',
            part6: 'From the distribution stations to the organizers!',
            part7: 'Donations are tax deductible (according to section 46).'
        },
        sitemap: {
            howItWorks: 'How it Works',
            whoWeAre: 'Who We Are',
            donateTo: 'Who the Donations Go To',
            distributionStations: 'List of Distribution Stations',
            registerAssociation: 'Register a New Organization',
            registerDistStation: 'Station Registration',
            enterProfile: 'To user area'
        },
        allOrgs: 'All the organizations',
        siteNotOpening: 'Dear friends, this year "Matanot Ktanot" will not be working as most of the members of the organization were serving in the army during the past period and unfortunately did not have time to organize the project this year...',
        willReturnNextYear: ' We promise to return with renewed strength next year, Happy Purim'
    }
});

export default homePageText